import FooterDownload from "components/Footer/FooterDownload.js";

import connectFunction from "redux/connectFunction";

function mapStateToProps(state) {
  return {
    categories: state.categories,
    city: state.city,
    attributes: state.attributes,
    user: state.user
  };
}

const FooterDownloadContainer = connectFunction(mapStateToProps)(
  FooterDownload
);
export default FooterDownloadContainer;
